/**
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import InRange from './InRange';

export default class ScaleSimulation {
  constructor (InitialState) {
    this.state = InitialState;
  }

  simulate (time) {
    time = Math.floor(time);
    const stateNum = time % 10;
    let offset = this.state.sim.offset;
    if (this.state.sim.lastStateNum === stateNum) {
      // Skip as state has been calculated before
      return false;
    }
    this.state.sim.lastStateNum = stateNum;

    if (stateNum === 0) {
      offset = ((time % 181) * 47) % 181 - 90;
      offset /= 1000;
    }
    this.state.data.labelStock = 100 - ((time / 10 + 352) % 1000) / 10;
    this.state.data.printMediaStock = 100 - ((time / 20 + 752) % 1000) / 10;
    const trgweights = [3.427, 6.755, 10.383];
    const trgWeight = trgweights[Math.floor(time / 10) % trgweights.length];
    const target = stateNum < 5 ? 0 : trgWeight + offset;
    const sign = stateNum < 5 ? -1 : 1;
    const gross = sign * 0.125 * Math.pow(2, -(stateNum % 5)) * Math.cos(Math.PI * (stateNum % 5) * 3 / 8) + target;
    const net = gross - this.state.sim.tare.num;
    this.state.data.curWeight.net.num = net;
    this.state.data.curWeight.gross.num = gross;
    this.state.data.inRange = gross < 0.1 ? InRange.Underload : gross > 10.0 ? InRange.Overload : InRange.Normal;
    this.state.data.highlightNew = false;
    if ((stateNum % 5) === 4 && this.state.data.inRange === InRange.Normal) {
      this.state.data.regWeight.net.num = net;
      this.state.data.regWeight.gross.num = gross;
      this.state.data.highlightNew = true;
      // Deep copy
      this.state.data.recentWeights.unshift(JSON.parse(JSON.stringify(this.state.data.regWeight)));
      this.state.data.recentWeights = this.state.data.recentWeights.slice(0, 5);
    }
    this.state.sim.offset = offset;
    return true;
  }
}
